export enum OutOfStockBehavior {
  WARNING = "WARNING",
  BLOCK_SALE = "BLOCK_SALE",
  ALLOW = "ALLOW",
}
